import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";

import {
    MyDate,
    myAxios,
    outsideDailydefaultEmptyData,
    standbyWeeks,
    weeknum,
} from "src/components/common/functions";

export async function checkInLoader({ params }: LoaderFunctionArgs) {
    const fallbackWeek = weeknum(new MyDate().s());
    const selectedWeek = params.week && standbyWeeks.includes(params.week) ? params.week : fallbackWeek;
    if (params.week !== selectedWeek) {
        throw redirect(`/CheckIn/${selectedWeek}`);
    }

    const formData = new FormData();
    formData.append("week", selectedWeek);
    formData.append("action", "Read");
    const res = await myAxios({ fileName: "outside/checkIn/checkIn.php", formData });
    if (!res) throw redirect("/");

    return {
        week: selectedWeek,
        form: JSON.parse(res.data?.[selectedWeek] || outsideDailydefaultEmptyData),
    };
}

export async function checkInAction({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    await myAxios({ fileName: "outside/checkIn/checkIn.php", formData });
}
